import {Component, Inject, OnInit} from "@angular/core";
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";

@Component({
  selector: "app-info-modal",
  templateUrl: "./info-modal.component.html",
  styleUrls: ["./info-modal.component.scss"],
})
export class InfoModalComponent implements OnInit {
  public showModalState = false;
  public isError = true;
  public successIcon = String.fromCodePoint(0x1f389);
  public errorText = "";

  constructor(
    private dialogRef: DialogRef<"REPEAT" | "DOWNLOAD" | "CLOSE">,
    @Inject(DIALOG_DATA) private data: {
      isError: boolean;
      errorText?: string;
    },
  ) {
    this.isError = this.data.isError;
    this.errorText = this.data.errorText || "";
  }

  ngOnInit(): void {
  }

  closeModal() {
    this.dialogRef.close(null);
  }

  onRepeatButtonClick() {
    this.dialogRef.close("REPEAT");
  }

  onDownloadButtonClick() {
    this.dialogRef.close("DOWNLOAD");
  }

  async onCompleteButtonClick() {
    this.dialogRef.close("CLOSE");
  }

  onCopyErrorTextToClipClick() {
    navigator.clipboard.writeText(this.errorText).then(function () {
      console.log('Copying to clipboard was successful!');
    }, function (err) {
      console.error('Could not copy text: ', err);
    });
  }
}
